import styled from "styled-components";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

import { breakpoints } from "@/styles/breakpoints";

export const StyledFilters = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid var(--color-grey-700);
`;

export const StyledTabs = styled(Tabs)`
    .tab-indicator {
        background-color: var(--color-secondary);
    }
`;

export const StyledTab = styled(Tab)`
    &.tab-root {
        @media ${breakpoints.xsMin} {
            min-width: 120px;
        }
        display: block;
        font-size: var(--size-16);
        line-height: 22px;
        color: var(--color-grey-800);
        text-transform: initial;
    }

    .quantity {
        padding: 0 8px;
        margin-left: 5px;
        background-color: var(--color-grey-600);
        border-radius: var(--radius-10);
    }
    &.tab-selected {
        .tab-wrapper {
            font-weight: bold;
            color: var(--color-secondary);
        }
        .quantity {
            background-color: var(--color-secondary-light);
        }
    }
`;
